import {roleMS} from "./roleMS.model";

export class RoleUserMS {
  id : number;
  user_id: number;
  user_name: string;
  user_surname: string;
  user_login: string;
  role: roleMS;
}


// WEBPACK FOOTER //
// ./src/app/models/roleUserMS.model.ts